import { makeApiCall } from "../apiRequest";
import { setAuthItem } from "@/utils/authStorage";
import { isTrialPlanName } from "@/constants/trialVersion";

export default {
  state: {
    adminData: [],
    organizationId: null,
    roomround_access_token: null,
    loginInformation: null,
  },
  getters: {
    getAdminData: (state) => state.adminData,
    getOrganizationId: (state) => state.organizationId,
    getRoomRoundAccessToken: (state) => state.roomround_access_token,
    getLoginInformation: (state) => state.loginInformation,
  },
  actions: {
    storeUserData({ commit }, payload) {
      commit("setOrganizationId", payload.organizationId);
      commit("setRoomRoundAccessToken", payload.token);
      commit("setRoomRoundLoginUserInformation", payload);
    },
    async userLogin({ commit }, payload) {
      const response = await makeApiCall("auth/login", "POST", payload);
      if (response.data.data) {
        const token = response.data.data.token;
        setAuthItem("roomround_access_token", token);
        setAuthItem("user_id", response?.data?.data.userId);
        
      } else {
        return response;
      }
      return response;
    },
    async getAdminData({ commit }, id) {
      let url = `auth/loginAsAdmin?organizationId=${id}`;
      const response = await makeApiCall(url, "GET");
      if (!response.error && response.data) {
        let adminPayload = response.data;
        try {
          const subRes = await makeApiCall(
            "subscriptionPlan/getUserSubscriptionHistory",
            "POST",
            { isPagination: false }
          );
          if (subRes?.data?.succeeded && Array.isArray(subRes.data.data)) {
            const now = new Date();
            const active = subRes.data.data.find((item) => {
              const start = new Date(item.startDate);
              const end = new Date(item.endDate);
              return (
                !Number.isNaN(start.getTime()) &&
                !Number.isNaN(end.getTime()) &&
                now >= start &&
                now <= end
              );
            });
            if (active && adminPayload.data) {
              const isFreeOrTrial = isTrialPlanName(active.planName);
              adminPayload = {
                ...adminPayload,
                data: {
                  ...adminPayload.data,
                  activeSubscription: active,
                  planName: adminPayload.data.planName || active.planName,
                  isPaid: isFreeOrTrial
                    ? false
                    : adminPayload.data.isPaid || active.amount > 0,
                  isTrial: isFreeOrTrial ? true : adminPayload.data.isTrial,
                  isFree:
                    String(active.planName || "")
                      .trim()
                      .toLowerCase() === "free",
                },
              };
            }
          }
        } catch (subErr) {
          console.warn("Could not enrich subscription in getAdminData:", subErr);
        }
        commit("setAdminData", adminPayload);
      }
      return response;
    },
    async updateUser({ commit }, payload) {
      let url = `settings/updateMap`;
      const response = await makeApiCall(url, "POST", payload);
      return response.data;
    },
    async confirmEmail({ commit }, payload) {
      const ForgotPasswordURL = `auth/forgetPassword?email=${encodeURIComponent(
        payload.email
      )}`;
      const response = await makeApiCall(ForgotPasswordURL, "POST", payload);
      return response.data;
    },

    async resetPassword({ commit }, payload) {
      const url = `auth/changePassword`;
      const response = await makeApiCall(url, "POST", payload);
      return response.data;
    },
  },
  mutations: {
    setAdminData: (state, payload) => (state.adminData = payload),
    setOrganizationId(state, organizationId) {
      state.organizationId = organizationId;
    },
    setRoomRoundAccessToken(state, token) {
      state.roomround_access_token = token;
    },
    setRoomRoundLoginUserInformation(state, payload) {
      state.loginInformation = payload;
    },
  },
};
